import { Pane } from 'evergreen-ui';
import React from 'react';

type ClientProfileLayoutProps = {
    topBar?: React.ReactNode;
    topRow: React.ReactNode;
    bottomRow: React.ReactNode;
    detailsExpanded?: boolean;
}

export const ClientProfileLayout = ({topBar, topRow, bottomRow, detailsExpanded = true} : ClientProfileLayoutProps)  => {
    // BHPNPP-3030: the client-details top-bar zone is tall when expanded (header + demographics + the two care cards)
    // and short when collapsed (header row only). Reserve accordingly so the content panel fills the rest.
    const topBarAllowance = detailsExpanded ? 290 : 75;
    // The line below sizes the tab content: screen height, minus the header, top bar and tab row.
    // On a short screen that subtraction leaves nothing for the table, and the table inside collapses to zero rows
    // while the pagination above it still counts a full page. A Windows laptop at 150% display
    // scaling reports about 620px and does exactly this (BHPNPP-3268). max() puts a floor under it.
    // 680 costs no extra scrollbar, because the left navbar is already taller than this column.
    const minContentHeight = 680;
    return (
        <Pane height='100%'>
            <Pane display='flex flex-col' padding='16px'>
                {topBar && <div className='mb-4'>{topBar}</div>}
                <div>{topRow}</div>
                <div style={{height: `max(${minContentHeight}px, calc(100vh - 100px - 37px - 60px - ${topBarAllowance}px))`}}>{bottomRow}</div>
            </Pane>
        </Pane>
    );
}
